import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

const investmentTransactions = (account) => {
  const postedOnDate = DateTime.local().minus({ days: 1 });
  const postedOn = postedOnDate.toISODate();

  const defaultProps = () => ({
    source: 'QCS_REFRESH',
    accountId: account?.id,
    postedOn,
    payee: 'Aggregated Txn 2900',
    coa: {
      type: 'UNCATEGORIZED',
    },
    acquisitionOn: DateTime.local().minus({ months: 1 }).toISODate(),
    currency: 'USD',
    state: 'CLEARED',
    knownCategoryId: '4500900000',
    cpData: {
      id: uuidv4(),
      postedOn,
      txnOn: postedOn,
      payee: 'Aggregated Txn 1',
      inferredPayee: 'Aggregated Txn 1',
      inferredCoa: {
        type: 'UNCATEGORIZED',
      },
      cpCategoryId: '1207',
    },
    type: 'INVESTMENT',
    securityId: 'QEXP-2',
    securityIdType: 'CUSIP',
    // localSecurityId,
  });

  return [
    {
      ...defaultProps(),
      payee: 'no investmentTxnType',
      units: 11,
      commission: -0.12,
      costBasis: 11 * -12.34 - 0.12,
      amount: 11 * -12.34 - 0.12,
      securityType: 'STOCK',
      symbol: 'AAPL',
      securityName: 'Apple Inc',
      cpData: {
        ...defaultProps().cpData,
        amount: 11 * -12.34 - 0.12,
      },
    },
    {
      ...defaultProps(),
      payee: 'only date and amount',
      amount: 2 * 56.78 - 0.1,
      cpData: {
        ...defaultProps().cpData,
        amount: 2 * 56.78 - 0.1,
      },
    },
    {
      ...defaultProps(),
      payee: 'no units',
      investmentTxnType: 'STOCK_DIVIDEND',
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      cpData: {
        ...defaultProps().cpData,
      },
    },
    {
      ...defaultProps(),
      payee: 'no symbol',
      investmentTxnType: 'REINVEST_DIVIDEND',
      securityType: 'STOCK',
      units: 10,
      commission: -0.1,
      amount: 10 * -11.22 - 0.1,
      cpData: {
        ...defaultProps().cpData,
        amount: 10 * -11.22 - 0.1,
      },
    },
  ];
};

export default investmentTransactions;
